const convertedVapidKey = urlBase64ToUint8Array(
  `BERuBi5GbdTdv42YNw66tetFD8okL22ORryU5YGF9b1wsYtK6ZjRfyqoQ-Xhvy0IZ1Kx1CqBHZR5BsOn6hzoxWs`
);

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  // eslint-disable-next-line
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function sendSubscription(subscription, getState) {
  let headers = {
    "Content-Type": "application/json",
  };
  // Get token from state
  const token = getState().auth.token;

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  console.log(subscription);

  return fetch(`${process.env.REACT_APP_API_BASE_URL}/push`, {
    method: "POST",
    body: JSON.stringify({ subscription }),
    headers,
  });
}

export function subscribeUser(getState) {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then(function (registration) {
        if (!registration.pushManager) {
          console.log("Push manager unavailable.");
          return;
        }

        registration.pushManager
          .getSubscription()
          .then(function (existedSubscription) {
            if (existedSubscription === null) {
              console.log("No subscription detected, make a request.");
              registration.pushManager
                .subscribe({
                  applicationServerKey: convertedVapidKey,
                  userVisibleOnly: true,
                })
                .then(function (newSubscription) {
                  console.log("New subscription added.");
                  sendSubscription(newSubscription, getState);
                })
                .catch(function (e) {
                  if (Notification.permission !== "granted") {
                    console.log("Permission was not granted.");
                  } else {
                    console.error(
                      "An error ocurred during the subscription process.",
                      e
                    );
                  }
                });
            } else {
              console.log("Existed subscription detected.");
              sendSubscription(existedSubscription, getState);
            }
          });
      })
      .catch(function (e) {
        console.error(
          "An error ocurred during Service Worker registration.",
          e
        );
      });
  }
}
